import { useContext, useEffect, useState } from "react";
import { ColorValue, StatusBar } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { View } from "react-native";
import React from "react";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { PlaceColors } from "../helpers/PlaceColors";

type TopBarOverlayProps = {
    color?: string;
}
export const FindifyTopBarOverlay = ({ color }: TopBarOverlayProps) => {
    const insets = useSafeAreaInsets();
    const findifyDataContext = useContext(FindifyDataContext);
    const [topColor, setTopColor] = useState(color ? color as ColorValue : PlaceColors(findifyDataContext).background.withAlpha(128));

    useEffect(() => {
        // if 6 digits hex string add default opacity
        if (typeof color === 'string'
            && color.length === 7
            && !isNaN(Number('0x' + color.slice(1)))
        ) {
            setTopColor(`${color}80` as ColorValue);
        }
    }, [color])

    return <View style={{
        position: 'absolute',
        top: 0,
        paddingTop: insets.top,
        backgroundColor: topColor,
        width: '100%',
        zIndex: 2
    }}>
        <StatusBar translucent={true} backgroundColor={topColor} barStyle={`${findifyDataContext?.darkMode ? 'light' : 'dark'}-content`} />
    </View>
}